import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IBulkAssignEmployeesAndGroupsData {
  id: any;
  all_users?: number;
  user_ids: Array<any>;
  group_ids: Array<any>;
}

const bulkAssignEmployeesAndGroups = ({ id, ...postData }: IBulkAssignEmployeesAndGroupsData) => {
  const updatedEndpoints = endpoints.job.bulkAssignEmployeeAndGroupsToJobs.replace('{id}', id);
  return http().post(updatedEndpoints, postData);
};

export function useBulkAssignEmployeesAndGroups() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: bulkAssignEmployeesAndGroups,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchPaginatedJobs'] });
      }
    },
  });
}
